import { render, staticRenderFns } from "./CarNumberChangesHistoryClient.vue?vue&type=template&id=62cd0022&scoped=true"
import script from "./CarNumberChangesHistoryClient.vue?vue&type=script&lang=js"
export * from "./CarNumberChangesHistoryClient.vue?vue&type=script&lang=js"
import style0 from "./CarNumberChangesHistoryClient.vue?vue&type=style&index=0&id=62cd0022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cd0022",
  null
  
)

export default component.exports